export const ANALYTICS_REFETCH_INTERVAL = 1000 * 30
